import { c as _c } from "react/compiler-runtime";
import type { RequestError } from '@onefootprint/request';
import { useRequestError } from '@onefootprint/request';
import { useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const useIdvRequestErrorToast = () => {
  const $ = _c(4);
  const {
    toast
  } = useToast();
  const {
    getErrorMessage
  } = useRequestError();
  const {
    t
  } = useTranslation("idv");
  let t0;
  if ($[0] !== getErrorMessage || $[1] !== t || $[2] !== toast) {
    t0 = error => {
      const description = getErrorMessage(error);
      const title = t(_temp);
      toast({
        description: description === title ? undefined : description,
        title,
        variant: "error"
      });
    };
    $[0] = getErrorMessage;
    $[1] = t;
    $[2] = toast;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const notify = t0;
  return notify;
};
export default useIdvRequestErrorToast;
function _temp($) {
  return $.global.errors["error-toast"].title;
}